<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Ajout des <strong>Approvisionnements / Entités</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Montant (*)</label>
              <b-form-input type="number" v-model="appro.montant" placeholder="Montant de l'approvisionnement"></b-form-input>
            </b-col>
            <b-col md="6" v-if="display_entity">
              <!-- <label for="entite_id">Entité (*)</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="appro.entite_id">
              </b-form-select> -->
              <label for="entite_id">Entite *</label>
                <el-select style="display:block;"
                  v-model="appro.entite_id"
                  loading-text="Chargement en cours"
                  no-match-text="Entité non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre entité"
                  :remote-method="remoteEntities"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
              </el-select>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('approvisionnement-create-for-entite')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      display_entity :true,
      appro:{
            montant: '',
            entite_id: ''
      },
      t : [],
      entities:[],
      options4: [],
      options5: [],
      value9: [],
      list: [],
      loading: false,
      states: []
    }
  },
  methods:{
    goBack() {
        this.$router.go(-1)
      },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async post(){    
      
      this.response = await this.$store.dispatch('appro/post_approvisionnementEntite',this.appro)
        this.showAlert()   
        if(this.response.success == true){
          this.reset()
          let solde = await api.atm.get_auth_guichets(token)
          localStorage.setItem('solde', solde.data.data.solde)
          window.open(this.response.data.content, "_blank")
          setTimeout(function(){ location.reload(); }, 3000);
        }
    },
    async get_all_entities(query){
        if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
          let serverParams= {
            page:1,
            current_page: 1,
            paginate: 10,
            nom_commercial: query,
          }
          await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
          })
          this.entities.forEach((element)=>{
              this.options.push({
                value:element.id,
                text:element.nom_commercial.toUpperCase(),
              })
          })
          this.t = this.options
        }else{
            this.display_entity =false
            this.appro.entite_id = this.$route.params.entite_id
            this.options.push({
              value:this.$route.params.entite_id,
              text:this.$route.params.entite_id
            })
        }
    },
    get_all_approvisionnemententite(){
        return this.rows =  store.getters['appro/rowsEntite'];
    },
    can(perm){
            return store.getters['auth/can'](perm)
    },
    reset(){
        this.appro.montant= ''
    },
    remoteEntities(query) {
        this.get_all_entities(query)
        console.log("ma requete 1",this.t)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.t.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          console.log("ma requete 2 ",this.t)
        } else {
          this.options4 = [];
        }
        this.options = [] 
        // console.log("ma requete 3 ",this.options)
    },
  },
  mounted(){
    this.get_all_entities('')
    this.get_all_approvisionnemententite()
  }
}
</script>
